import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { THEME_STORAGE_KEY } from "./atoms/themeAtom";
import "./styles/theme.scss";
import "./styles/global.scss";
// Applied synchronously, before React mounts, so there's no flash of the wrong
// theme while the bundle boots. useApplyTheme takes over from here for reactive
// updates once the app is running.
function readStoredThemePreference() {
    try {
        const raw = localStorage.getItem(THEME_STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : "auto";
        return parsed === "light" || parsed === "dark" ? parsed : "auto";
    }
    catch (_a) {
        return "auto";
    }
}
const initialTheme = readStoredThemePreference();
if (initialTheme !== "auto") {
    document.documentElement.dataset.theme = initialTheme;
}
const container = document.getElementById("root");
if (!container) {
    throw new Error("Root element not found.");
}
createRoot(container).render(_jsx(BrowserRouter, { children: _jsx(App, {}) }));
